module.exports = __webpack_public_path__ + "static/media/intro-3--dark.88184141.png";